(function($) {
	$.fn.originGroupboxContent = function() {
		return this.find('> div.groupboxBody > div.groupboxContent:eq(0)');
	};
	$.fn.originGroupboxTitle = function() {
		return this.find('> div.groupboxHeader div.groupboxTitle:eq(0)');
	};
	
	Origin.onAction('groupboxClose', function(evt) {
		$(this).closest('.groupbox').trigger('groupboxclose');
	});
	
	Origin.onAction('groupboxExpand', function(evt) {
		$(this).closest('.groupbox').trigger('groupboxexpand');
	});
	
	Origin.onAction('groupboxCollapse', function(evt) {
		var $g = $(this).closest('.groupbox');
		$g	.toggleClass('groupboxCollapsed')
			.trigger('groupboxcollapse', [ { collapsed: $g.hasClass('groupboxCollapsed') } ] );
	});
	
	$('div.groupbox .groupboxHeader').on('dblclick', function(evt) {
		$(this).closest('.groupbox').find('.action-groupbox-collapse').click();
	});
})(jQuery);